module.exports = __webpack_public_path__ + "img/201110-2.b6f6fbbf.png";